import {
  isAllowedReferenceAudioFile,
  isAllowedReferenceImageFile,
  isAllowedReferenceVideoFile,
  isReferenceFileWithinSize,
} from "@/lib/reference-file-policy"

export type FlowFileNodeKind = "image" | "video" | "audio"

export type FlowPlacedFile = {
  file: File
  kind: FlowFileNodeKind
}

export type FlowFilePartition = {
  accepted: FlowPlacedFile[]
  rejectedType: boolean
  oversized: File | null
}

/** Картинка → image, видео → video, аудио → audio. Остальное и слишком большие файлы в accepted не попадают. */
export function partitionFlowFiles(files: File[]): FlowFilePartition {
  const accepted: FlowPlacedFile[] = []
  let rejectedType = false
  let oversized: File | null = null

  for (const file of files) {
    const kind = flowFileNodeKind(file)
    if (kind == null) {
      rejectedType = true
      continue
    }
    if (!isReferenceFileWithinSize(file)) {
      oversized ??= file
      continue
    }
    accepted.push({ file, kind })
  }

  return { accepted, rejectedType, oversized }
}

function flowFileNodeKind(file: File): FlowFileNodeKind | null {
  if (isAllowedReferenceImageFile(file)) return "image"
  if (isAllowedReferenceVideoFile(file)) return "video"
  if (isAllowedReferenceAudioFile(file)) return "audio"
  return null
}

/** Лесенка в координатах доски: шаг одинаковый на экране при любом зуме. */
export function flowFileCascadeOffset(index: number, zoom: number, screenPx = 24): number {
  const step = screenPx / (zoom > 0 ? zoom : 1)
  return index * step
}

export type FlowPasteAnchor = { id: number; x: number; y: number }

/** Каждая следующая вставка сдвигается ещё на один шаг лесенки от позиций в момент копирования. */
export function flowPastePositions(
  nodes: readonly FlowPasteAnchor[],
  pasteCount: number,
  zoom: number,
): { id: number; positionX: number; positionY: number }[] {
  const step = flowFileCascadeOffset(pasteCount, zoom)
  return nodes.map((node) => ({
    id: node.id,
    positionX: node.x + step,
    positionY: node.y + step,
  }))
}
